import React from 'react';
import PropTypes from 'prop-types';

// Utils & misc
import cn from '../../utils/cn';

import style from './IconNotif.module.css';

const IconNotif = ({ icon, number, className }) => (
  <div className={cn([className, style.notif])}>
    <i className={icon} />
    {number > 0 ? <span className={style.badge}>{number}</span> : null}
  </div>
);

IconNotif.propTypes = {
  icon: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  className: PropTypes.string,
};

IconNotif.defaultProps = {
  className: null,
};

export default IconNotif;
